const mapboxConfig = {
  maxZoomLevel: 20,
  minZoomLevel: 4,
  panAnimationDuration: 500,
  initialViewportState: {
    longitude: 174.7633,
    latitude: -36.8485,
    zoom: 14,
    bearing: 0,
    pitch: 0,
  },
  clusterMaxZoom: 14,
  clusterRadius: 95,
};

export const mapData = {
  zoomLevel: {
    min: 1,
    pin: 16,
    max: 14,
    initial: 10,
  },
};

export default mapboxConfig;